module.exports = __webpack_public_path__ + "a318275c6ab6b9907a0d55c28ba7a37f.png";